import layoutDetail from '@/layouts/layout-detail.vue'

export default [
  {
    path: '/product/:id',
    redirect: '/product',
    component: layoutDetail,
    /* hidden: true, */
    children: [{
      path: '',
      name: 'product',
      component: resolve => require.ensure([], () => resolve(require('@/views/detail/index.vue')), 'product'),
      meta: { title: '详情页', icon: '' }
    }]
  }
]
